export default __webpack_public_path__ + "static/media/home-hero-meteor-large.770913a6.png";